/* L&S: Versand-Rechner im Vorteils-Banner. Rechnet bei jeder Warenkorb-Änderung neu. */
if (!customElements.get('ls-shipping-progress')) {
  customElements.define(
    'ls-shipping-progress',
    class LsShippingProgress extends HTMLElement {
      connectedCallback() {
        this.threshold = parseInt(this.dataset.threshold, 10) || 0;
        this.text = this.querySelector('[data-ls-shipping-text]');
        this.bar = this.querySelector('[data-ls-shipping-bar]');
        this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
          style: 'currency',
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
        });

        // Klick auf die Zeile öffnet die Warenkorb-Schublade (ohne Schublade: normaler Link zur Warenkorbseite)
        const cartLink = this.querySelector('[data-ls-shipping-cart]');
        if (cartLink) {
          cartLink.addEventListener('click', (event) => {
            const drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.open === 'function') {
              event.preventDefault();
              drawer.open(cartLink);
            }
          });
        }

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
        }
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      refresh() {
        fetch(`${window.routes ? window.routes.cart_url : '/cart'}.js`, { headers: { Accept: 'application/json' } })
          .then((response) => response.json())
          .then((cart) => this.render(cart.total_price))
          .catch(() => {});
      }

      render(total) {
        const remaining = this.threshold - total;
        let message;
        if (total <= 0) {
          message = this.dataset.textEmpty;
        } else if (remaining > 0) {
          message = this.dataset.textRemaining.replace('[betrag]', this.formatter.format(remaining / 100));
        } else {
          message = this.dataset.textReached;
        }
        if (this.text) this.text.textContent = message;
        if (this.bar && this.threshold > 0) {
          this.bar.style.width = `${Math.min(100, Math.round((total / this.threshold) * 100))}%`;
        }
        this.toggleAttribute('data-reached', total > 0 && remaining <= 0);
      }
    }
  );
}
